import { useState } from 'react';

export default function Home() {
  const [showDeliveryInfo, setShowDeliveryInfo] = useState(false);

  const products = [
    {
      id: 1,
      name: 'Muối ớt đỏ OXY',
      description: 'Đậm đà, thơm tự nhiên',
      price: '39.000đ',
      image: 'https://static.readdy.ai/image/8d21a46d9c64e98c46e59a71b72dab68/784e548e4323a083af3ee388ed056c0f.jpeg'
    },
    {
      id: 2,
      name: 'Muối ớt Xanh OXY – Vị cay nồng',
      description: 'Đậm vị ớt, cay nồng',
      price: '39.000đ',
      image: 'https://static.readdy.ai/image/8d21a46d9c64e98c46e59a71b72dab68/536b50c5fa9e15071d1f110b457c3f84.jpeg'
    },
    {
      id: 3,
      name: 'Sốt Chấm Tiêu Đen OXY – Vị đặc biệt',
      description: 'Hương vị tổng hợp, phù hợp mọi món',
      price: '39.000đ',
      image: 'https://static.readdy.ai/image/8d21a46d9c64e98c46e59a71b72dab68/d74e6f82cfb9ea879fc756bc5fa2b75a.jpeg'
    }
  ];

  const dishes = [
    {
      id: 1,
      name: 'Thịt nướng',
      image: 'https://public.readdy.ai/ai/img_res/61290b351b6898b4a6caa2c1568671e1.jpg'
    },
    {
      id: 2,
      name: 'Hải sản nướng',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20grilled%20seafood%20platter%2C%20red-orange%20grilled%20shrimp%20and%20golden%20squid%2C%20light%20smoke%20effect%20creating%20aromatic%20atmosphere%2C%20vibrant%20colors%2C%20professional%20food%20photography%2C%20bright%20warm%20lighting%2C%20shallow%20depth%20of%20field%2C%20isolated%20on%20clean%20white%20background%2C%20top%20view%20angle%2C%20high%20detail%20quality%2C%20realistic%20food%20styling&width=400&height=300&seq=dish2&orientation=landscape'
    },
    {
      id: 3,
      name: 'Thịt luộc',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20boiled%20pork%20belly%20slices%2C%20white%20and%20light%20pink%20color%2C%20served%20with%20fresh%20green%20vegetables%2C%20natural%20colors%2C%20professional%20food%20photography%2C%20bright%20clean%20lighting%2C%20shallow%20depth%20of%20field%2C%20isolated%20on%20clean%20white%20background%2C%20top%20view%20angle%2C%20high%20detail%20quality%2C%20realistic%20food%20styling&width=400&height=300&seq=dish3&orientation=landscape'
    },
    {
      id: 4,
      name: 'Hải sản luộc',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20boiled%20seafood%20platter%2C%20fresh%20shrimp%20clams%20and%20squid%2C%20natural%20vibrant%20colors%2C%20not%20grilled%20or%20charred%2C%20professional%20food%20photography%2C%20bright%20clean%20lighting%2C%20shallow%20depth%20of%20field%2C%20isolated%20on%20clean%20white%20background%2C%20top%20view%20angle%2C%20high%20detail%20quality%2C%20realistic%20food%20styling&width=400&height=300&seq=dish4&orientation=landscape'
    },
    {
      id: 5,
      name: 'Cánh gà chiên',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20fried%20chicken%20wings%2C%20golden%20crispy%20skin%20with%20honey%20glaze%20color%2C%20beautifully%20browned%2C%20appetizing%20appearance%2C%20professional%20food%20photography%2C%20bright%20warm%20lighting%2C%20shallow%20depth%20of%20field%2C%20isolated%20on%20clean%20white%20background%2C%20top%20view%20angle%2C%20high%20detail%20quality%2C%20realistic%20food%20styling&width=400&height=300&seq=dish5&orientation=landscape'
    },
    {
      id: 6,
      name: 'Rau củ luộc',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20boiled%20vegetables%20platter%2C%20broccoli%20carrots%20and%20green%20beans%2C%20fresh%20vibrant%20colors%20with%20light%20glossy%20appearance%2C%20professional%20food%20photography%2C%20bright%20clean%20lighting%2C%20shallow%20depth%20of%20field%2C%20isolated%20on%20clean%20white%20background%2C%20top%20view%20angle%2C%20high%20detail%20quality%2C%20realistic%20food%20styling&width=400&height=300&seq=dish6&orientation=landscape'
    }
  ];

  const brandFeatures = [
    {
      icon: 'ri-leaf-line',
      title: 'Nguồn gốc tự nhiên',
      description: 'Sản phẩm được chế biến từ nguyên liệu tươi ngon nhất vùng núi Chứa Chan, nơi có khí hậu và đất đai lý tưởng cho cây ớt và tiêu.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Làm thủ công',
      description: 'Mỗi lọ nước chấm OXY đều được làm thủ công tỉ mỉ, giữ trọn hương vị đậm đà và dinh dưỡng của nguyên liệu.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'An toàn tuyệt đối',
      description: '100% không chất bảo quản — an toàn cho gia đình.'
    }
  ];

  return (
    <div className="w-full max-w-[375px] mx-auto bg-gradient-to-b from-[#F8F6F4] via-[#FFF9F5] to-[#F5F1ED] min-h-screen">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50 max-w-[375px] mx-auto">
        <div className="flex items-center justify-between px-4 py-3">
          <img 
            src="https://static.readdy.ai/image/8d21a46d9c64e98c46e59a71b72dab68/49ec86c431b447b2a62c0d58be6d3af9.jpeg" 
            alt="OXY Garden Logo" 
            className="h-12 w-auto object-contain"
          />
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-menu-line text-2xl" style={{ color: '#0D1321' }}></i>
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-16">
        {/* Banner */}
        <section className="relative h-[400px] overflow-hidden">
          <img 
            src="https://static.readdy.ai/image/8d21a46d9c64e98c46e59a71b72dab68/e34546c68007f1d65ec570d2dc56acfa.jpeg"
            alt="Banner"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/60"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-end pb-8 px-6 text-center">
            <h1 className="text-white text-3xl font-bold mb-2" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              Ưu Đãi Đặc Biệt
            </h1>
            <p className="text-white text-xl font-semibold mb-1" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              Mua Bộ 3 – Giảm ngay 10%
            </p>
            <p className="text-white text-2xl font-bold mb-6" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              Chỉ còn 109.000đ thay vì 117.000đ
            </p>
            <a 
              href="tel:0865065479"
              className="bg-[#D62828] text-white px-10 py-5 rounded-2xl font-bold text-xl shadow-2xl hover:bg-[#E63939] transition-all transform hover:scale-105 animate-pulse border-4 border-white/30"
              style={{ 
                boxShadow: '0 0 30px rgba(214, 40, 40, 0.6), 0 10px 40px rgba(0,0,0,0.3)',
                textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
              }}
            >
              🔥 Đặt hàng ngay
            </a>
          </div>
        </section>

        {/* Main Product Section */}
        <section className="px-4 py-8 bg-gradient-to-b from-white/80 to-[#FFF9F5]/80">
          <div className="text-center mb-6">
            <h2 className="text-3xl font-bold mb-4 text-[#D62828]">
              NƯỚC CHẤM OXY FOOD
            </h2>
            <div className="space-y-2 text-gray-700 mb-6">
              <p className="flex items-center justify-center gap-2">
                <i className="ri-checkbox-circle-fill text-[#D62828]"></i>
                Nguyên liệu tự nhiên, vị đậm đà
              </p>
              <p className="flex items-center justify-center gap-2">
                <i className="ri-checkbox-circle-fill text-[#D62828]"></i>
                Phù hợp món nướng, chiên, luộc, hải sản
              </p>
              <p className="flex items-center justify-center gap-2">
                <i className="ri-checkbox-circle-fill text-[#D62828]"></i>
                Dùng để chấm hoặc tẩm ướp
              </p>
              <p className="flex items-center justify-center gap-2">
                <i className="ri-checkbox-circle-fill text-[#D62828]"></i>
                Hoàn toàn không chất bảo quản
              </p>
            </div>
            <div className="mb-6">
              <p className="text-gray-400 line-through text-lg mb-1">117.000đ</p>
              <p className="text-[#D62828] text-3xl font-bold">Chỉ còn 109.000đ</p>
            </div>
            
            <div>
              <a 
                href="tel:0865065479"
                className="inline-block bg-[#FF6A2A] text-white px-10 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-[#FF7A3A] transition-all"
              >
                Mua ngay
              </a>
            </div>
          </div>
        </section>

        {/* 3 Products Section */}
        <section className="px-4 py-8 bg-gradient-to-b from-[#FFF9F5]/80 to-white/80" data-product-shop>
          <h2 className="text-2xl font-bold text-center mb-6" style={{ color: '#0D1321' }}>
            Sản Phẩm Nổi Bật
          </h2>
          <div className="space-y-6">
            {products.map((product) => (
              <div 
                key={product.id}
                className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all border border-gray-100"
              >
                <div className="flex flex-col">
                  <div className="w-full aspect-square overflow-hidden bg-gradient-to-br from-gray-50 to-white">
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain p-6"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="font-bold text-lg mb-2" style={{ color: '#0D1321' }}>
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">{product.description}</p>
                    <div className="flex items-center justify-between">
                      <p className="text-[#D62828] font-bold text-2xl">{product.price}</p>
                      <a 
                        href="tel:0865065479"
                        className="bg-[#FF6A2A] text-white px-6 py-3 rounded-xl text-base font-semibold hover:bg-[#FF7A3A] transition-all shadow-lg"
                      >
                        Mua ngay
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Perfect with Every Dish */}
        <section className="px-4 py-8 bg-gradient-to-b from-white/80 to-[#FFF9F5]/80">
          <h2 className="text-2xl font-bold text-center mb-6" style={{ color: '#0D1321' }}>
            Hoàn hảo với mọi món ăn
          </h2>
          <div className="grid grid-cols-2 gap-3">
            {dishes.map((dish) => (
              <div 
                key={dish.id}
                className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={dish.image}
                    alt={dish.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-3 text-center">
                  <p className="font-semibold text-sm" style={{ color: '#0D1321' }}>{dish.name}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Brand Story */}
        <section className="px-4 py-8 bg-gradient-to-b from-[#FFF9F5]/80 to-white/80">
          <div className="bg-gradient-to-br from-[#F6F2ED] to-[#FFF9F5] rounded-2xl p-6 shadow-lg border border-gray-100">
            <div className="text-center mb-6">
              <h2 className="text-xl font-bold mb-2" style={{ color: '#0D1321' }}>
                Về Thương Hiệu
              </h2>
              <h3 className="text-2xl font-bold text-[#D62828]">
                NƯỚC CHẤM OXY FOOD
              </h3>
            </div>
            <div className="space-y-6">
              {brandFeatures.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#D62828] rounded-full flex-shrink-0">
                    <i className={`${feature.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-base mb-2" style={{ color: '#0D1321' }}>
                      {feature.title}
                    </h3>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Free Shipping Section - Before Footer */}
        <section className="px-4 py-6 bg-white/80">
          <div className="bg-[#D62828]/40 backdrop-blur-sm rounded-xl p-4 border border-white/60 shadow-md">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-[#D62828] rounded-full flex-shrink-0">
                <i className="ri-truck-line text-2xl text-white"></i>
              </div>
              <p className="text-gray-800 font-semibold text-sm">
                Miễn phí vận chuyển cho đơn từ 200.000đ
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-b from-[#0A0E1A] to-[#E6392F] text-white py-8 px-4 text-center" style={{ minHeight: '240px' }}>
        <div className="max-w-md mx-auto space-y-4">
          <div className="mb-4">
            <a 
              href="tel:0865065479"
              className="inline-flex items-center gap-2 text-2xl font-bold hover:text-gray-200 transition-all"
            >
              <i className="ri-phone-fill"></i>
              0865065479
            </a>
          </div>
          <div className="space-y-2 text-sm">
            <p className="flex items-center justify-center gap-2">
              <i className="ri-truck-line text-lg"></i>
              Giao hàng toàn quốc
            </p>
            <p className="flex items-center justify-center gap-2">
              <i className="ri-shield-check-line text-lg"></i>
              Cam kết chất lượng – đổi trả linh hoạt
            </p>
          </div>
          <div className="pt-4 border-t border-white/20 text-xs text-gray-300">
            <p>&copy; 2024 OXY Garden. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}